module.exports = __webpack_public_path__ + "img/appraisement.3632c144.png";